var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"custom-button",style:(("width: " + (_vm.size*1.5) + "px; height: " + (_vm.size*1.5) + "px;")),attrs:{"icon":""}},[_c('v-icon',{attrs:{"size":_vm.size,"color":"white"},domProps:{"textContent":_vm._s(_vm.icon)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }